// library imports
import { createSlice } from "@reduxjs/toolkit";

import { timeCurrentIso8601 } from "_core/utils/common";
import * as Constants from "_core/configs/Constants";

// 初期化
const saveKey = Constants.APP_KEY + "-" + Constants.SaveAccount;
const saveData = localStorage.getItem(saveKey);

const initialState = saveData
    ? JSON.parse(saveData)
    : {
        isLogin: true,
        profile: "",
        lastdate: timeCurrentIso8601()
    };

const AccountSlice = createSlice({
    name: "account",
    initialState,
    reducers: {

        /**
         * プロフィール更新
         * payload: string  新しいprofile
         */
        editAccount: (state, action) => {
            state.profile = action.payload;
            state.lastdate = timeCurrentIso8601();

            // 変更を保存
            const strings = JSON.stringify(state);
            localStorage.setItem(saveKey, strings);
        }
    },
});

export const { editAccount } = AccountSlice.actions;
export default AccountSlice.reducer;